// from general.js
/* global getParameterByName */


(function () {
    setAmounts();
    $('.js-tier').on('click', function (e) {
        e.preventDefault();
        let monthlyAmount;
        setAmounts();

        if (e.target.classList.contains('tier')) {
            monthlyAmount = $(e.target).find('.js-num').attr('data-value');
        } else {
            monthlyAmount = $(e.target).parents('.js-tier').find('.js-num').attr('data-value');
        }
        $('#donationAmount').val(monthlyAmount);
        $('#simpleWidgetForm').submit();
    });
    $('.js-give-custom').on('click', function () {
        $(this).hide();
        $('.form-redux').show();
    });

    function setAmounts() {
        if (getParameterByName('amt') !== '') {
            const values = getParameterByName('amt').split(',');

            $('.js-tier').each(function (i, tier) {
                $(tier).find('.js-num').attr('data-value', values[i]);
                $(tier).find('.js-num').text('$' + values[i]);
            });
        }
    }
})();
